export default "__VITE_ASSET__5c272cee__"